import { useEffect, useState, useCallback } from 'react';

// Tiny hash-routing hook. Routes look like `#/createContract`. Returns the
// path segments (so `#/createContract` → ['createContract']) plus a
// programmatic navigate(). Falls back to ['' ] when the hash is empty.

function readHash(): string[] {
  const raw = typeof window !== 'undefined' ? window.location.hash : '';
  // Strip leading "#/" or "#"
  const path = raw.replace(/^#\/?/, '');
  return path.split('/').filter(Boolean);
}

export function useHashRoute(): {
  segments: string[];
  navigate: (to: string) => void;
} {
  const [segments, setSegments] = useState<string[]>(readHash);

  useEffect(() => {
    const onChange = () => setSegments(readHash());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  const navigate = useCallback((to: string) => {
    const normalized = to.replace(/^#?\/?/, '');
    window.location.hash = `#/${normalized}`;
  }, []);

  return { segments, navigate };
}
